<template>
  <div class="page-wrapper">
    <div class="container">
      <!-- content -->
      <div class="content">
        <div class="row">
          <div class="col-md-12">
            <div class="container search-content">
              <h2 class="text-uppercase">SEND A COMPLAINT ABOUT {{ coachName }}</h2>
            </div>
            <div class="report-text">
              <p>
                TNA's first priority is Player Safety.If a Coach has sent you an inappropriate message, please take a screenshot of the
                conversation and file an official complaint. All formal complaints will be investigated and proper action will be taken
                immediately.
              </p>
            </div>
            <div>
              <a-textarea
                class="complain-text-holder"
                v-model="complainText"
                placeholder="Enter your Complaint"
                :auto-size="{ minRows: 10, maxRows: 10 }"
              />
              <BaseDragUpload
                ref="dragUpload"
                multiple
                :upload-limit="4"
                class="padding-top-3"
                @file-upload="handleFileUpload"
              />
            </div>
            <div>
              <a-button
                type="primary"
                :disabled="!isDisabled"
                @click="handleComplain"
                :loading="complainPhotoLoading || complainLoading"
              >
                Send Complaint
              </a-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { Complain } from "@/models";

const COMPLAIN_STORE_KEY = "complainStore";

export default {
  data() {
    return {
      complainText: "",
      complainantId: Complain.profileId(),
      file: null,
      coachName: sessionStorage["coach-name"]
    };
  },
  computed: {
    ...mapGetters({
      complainId: `${COMPLAIN_STORE_KEY}/complainId`,
      complainLoading: `${COMPLAIN_STORE_KEY}/complainLoading`,
      complainPhotoLoading: `${COMPLAIN_STORE_KEY}/complainPhotoLoading`
    }),
    isDisabled() {
      return Boolean(this.complainText) && Boolean(this.file);
    },
    coachOf() {
      if (sessionStorage["coach-type"] === "collegeCoach") return "Coach";
      return "ClubCoach";
    }
  },
  methods: {
    async handleComplain() {
      await this.$store.dispatch(`${COMPLAIN_STORE_KEY}/createComplain`, {
        complainMessage: this.complainText,
        accusedProfileId: sessionStorage["coach-id"],
        coachOf: this.coachOf,
        complainantProfileId: this.complainantId,
        attachments: []
      });
      const image = new FormData();
      this.file.forEach((item, index) => image.append(`file${index}`, item));
      await this.$store.dispatch(`${COMPLAIN_STORE_KEY}/putComplainPhoto`, {
        complainId: this.complainId["_id"],
        image: image
      });
      this.complainText = "";
      this.file = null;
      this.$refs.dragUpload.handleClearAll();
    },
    handleFileUpload(file) {
      this.file = file;
    }
  },
  watch: {
    sessionStorage: {
      immediate: true,
      deep: true,
      handler: function() {
        if (!sessionStorage["coach-id"]) {
          this.$router.back();
        }
      }
    }
  }
};
</script>

<style lang="scss">
.report-text {
  color: #d73228;
  text-align: center;
  font-weight: 450;
}
</style>
